import {
  createContext,
  useContext,
  useState,
  useEffect,
  type ReactNode,
} from "react";
import { loadConfig, validateConfig } from "../config";
import { initTelemetry } from "../telemetry";

interface ConfigState {
  isLoading: boolean;
  errors: string[];
}

const ConfigContext = createContext<ConfigState>({
  isLoading: true,
  errors: [],
});

export function useConfig() {
  return useContext(ConfigContext);
}

export function ConfigProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<ConfigState>({
    isLoading: true,
    errors: [],
  });

  useEffect(() => {
    (async () => {
      try {
        await loadConfig();
        const validation = validateConfig();
        if (!validation.valid) {
          setState({ isLoading: false, errors: validation.errors });
          return;
        }
        initTelemetry();
        setState({ isLoading: false, errors: [] });
      } catch {
        setState({
          isLoading: false,
          errors: [
            "Failed to load configuration. Check that config.json exists.",
          ],
        });
      }
    })();
  }, []);

  return (
    <ConfigContext.Provider value={state}>{children}</ConfigContext.Provider>
  );
}
